/**
 * Возвращает функцию для проверки принадлежности переданного значения указанному enum
 * @param e - enum
 * @returns isSomeEnum(Enum) => (value: any) => boolean;
 */
export const isSomeEnum = <T extends Record<string, any>>(e: T) => (token: any): token is T[keyof T] => Object.values(e).includes(token as T[keyof T]);
